// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  overflow: hidden;
}

.modal-header {
  padding: 0 16px;
  margin: 0;
  min-height: 14px;
  display: flex;
  align-items: center;
}
.modal-header h2 {
  margin: 0;
  line-height: 1;
  padding: 2px 0;
}

mat-dialog-content {
  min-width: 300px;
  max-width: 100%;
  padding: 12px 16px;
  margin: 0;
  overflow: hidden;
}

mat-form-field {
  width: 100%;
  margin-bottom: 0;
}
mat-form-field ::ng-deep .mat-form-field-wrapper {
  margin: 0;
  padding-bottom: 0;
}

.modal-footer {
  padding: 4px 16px;
  margin: 0;
  overflow: hidden;
  min-height: 32px;
  display: flex;
  align-items: center;
}
.modal-footer mat-dialog-actions {
  padding: 0;
  margin: 0;
  min-height: auto;
  display: flex;
  justify-content: flex-end;
}

button {
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/CIIS/request-form/diport-input-dialog/diport-input-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,SAAA;EACA,cAAA;EACA,cAAA;AACJ;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,gBAAA;AAAF;AAEE;EACE,SAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AADF;AAGE;EACE,UAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AADJ;;AAKA;EACE,gBAAA;AAFF","sourcesContent":[":host {\r\n  display: block;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.modal-header {\r\n  padding: 0 16px;\r\n  margin: 0;\r\n  min-height: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  \r\n  h2 {\r\n    margin: 0;\r\n    line-height: 1;\r\n    padding: 2px 0;\r\n  }\r\n}\r\n\r\nmat-dialog-content {\r\n  min-width: 300px;\r\n  max-width: 100%;\r\n  padding: 12px 16px;\r\n  margin: 0;\r\n  overflow: hidden;\r\n}\r\n\r\nmat-form-field {\r\n  width: 100%;\r\n  margin-bottom: 0;\r\n  \r\n  ::ng-deep .mat-form-field-wrapper {\r\n    margin: 0;\r\n    padding-bottom: 0;\r\n  }\r\n}\r\n\r\n.modal-footer {\r\n  padding: 4px 16px;\r\n  margin: 0;\r\n  overflow: hidden;\r\n  min-height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  \r\n  mat-dialog-actions {\r\n    padding: 0;\r\n    margin: 0;\r\n    min-height: auto;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n  }\r\n}\r\n\r\nbutton {\r\n  margin-left: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
